import React, { memo } from "react";
import { useTranslation } from "react-i18next";

import { StyledRow } from "../../../../../../../../../components/common";
import { OrderFormProps } from "../../../types/FormProps";
import { Gray, Primary } from "../../styled";

const ExecutionTime: React.FC<ExecutionTime.Props> = () => {
	const { t } = useTranslation();

	return (
		<StyledRow gap="0 6px">
			<Primary>
				{`${t([`orderPage.order_form.execution`, "Fulfillment"])}:`}
			</Primary>
			<Gray>{"00:00:00"}</Gray>
		</StyledRow>
	);
};

declare namespace ExecutionTime {
	interface Props extends OrderFormProps {}
}
export const ExecutionTimeMemo = memo(ExecutionTime);
export default ExecutionTime;
